/* TWISTWIT storefront: cart drawer, gallery, menu. Add to cart is left to Kaching / the native form; the drawer opens after any /cart/add. */
(function () {
  var drawer = document.getElementById('tw-drawer');
  var inner = document.getElementById('tw-cart-inner');
  var menu = document.getElementById('tw-menu');

  window.__lntOpen = function () { return openDrawer.apply(this, arguments); }; function openDrawer() { drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }

  function refresh() {
    return fetch('/?sections=tw-cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j['tw-cart-drawer'] || '';
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var sec = tmp.firstElementChild;
        inner.innerHTML = sec ? sec.innerHTML : html;
        var body = inner.querySelector('[data-tw-n]');
        var n = body ? body.getAttribute('data-tw-n') : '0';
        document.querySelectorAll('[data-tw-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-n', n); });
      });
  }
  window.twCartRefresh = function () { return refresh().then(openDrawer); };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-tw-open],[data-tw-close],[data-tw-menu],[data-tw-qty]');
    if (!t) return;
    if (t.hasAttribute('data-tw-open')) { e.preventDefault(); refresh().then(openDrawer); }
    else if (t.hasAttribute('data-tw-close')) { closeDrawer(); }
    else if (t.hasAttribute('data-tw-menu')) { menu.classList.toggle('is-open'); }
    else if (t.hasAttribute('data-tw-qty')) {
      t.disabled = true;
      fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: t.getAttribute('data-tw-qty'), quantity: parseInt(t.getAttribute('data-q'), 10) }) })
        .then(refresh);
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  document.querySelectorAll('#tw-menu a').forEach(function (a) { a.addEventListener('click', function () { menu.classList.remove('is-open'); }); });

  /* open the drawer after any successful add (Kaching or native) */
  var pendingOpen = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) {
          if (r && r.ok && !pendingOpen) { pendingOpen = true; setTimeout(function () { pendingOpen = false; refresh().then(openDrawer); }, 250); }
        }).catch(function () {});
      }
      return p;
    };
  }

  /* native fallback when no bundle widget takes over the form */
  document.querySelectorAll('form[data-tw-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]');
      btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  });

  var gal = document.querySelector('[data-tw-gal]');
  if (gal) {
    var imgs = Array.prototype.slice.call(gal.querySelectorAll('.tw-gal__main img'));
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll('.tw-gal__thumbs button'));
    var cur = 0;
    var show = function (i) {
      cur = (i + imgs.length) % imgs.length;
      imgs.forEach(function (el, k) { el.classList.toggle('is-on', k === cur); });
      thumbs.forEach(function (el, k) { el.classList.toggle('is-on', k === cur); });
      var th = thumbs[cur]; if (th && th.scrollIntoView) th.parentNode.scrollLeft = th.offsetLeft - 40;
    };
    thumbs.forEach(function (b, k) { b.addEventListener('click', function () { show(k); }); });
    gal.querySelectorAll('[data-dir]').forEach(function (b) { b.addEventListener('click', function () { show(cur + parseInt(b.dataset.dir, 10)); }); });
    var main = gal.querySelector('.tw-gal__main'), x0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); x0 = null;
    });
    window.twShowImage = function (colour) {
      for (var k = 0; k < imgs.length; k++) { if ((imgs[k].getAttribute('data-col') || '') === colour) { show(k); return; } }
    };
  }
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the __LNT_NONE brand cart drawer ===== */
(function () {
  if (window.__tw_atc) return; window.__tw_atc = 1;
  function open() { if (window.__LNT_NONE && window.__LNT_NONE.openCart) return window.__LNT_NONE.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
